import { Component } from '@angular/core';

@Component({
  templateUrl: './reporting.page.html',
})
export class ReportingPageComponent {}
